import Vue from 'vue'
import moment from 'moment'
export default Vue.extend({
  props: ['value'],
  data() {
    return {
      day: 1,
      time: '',
    }
  },
  watch: {
    value(val) {
      console.log(val)
      this.day = val[0]
      this.time = val[1]
    },
    day(val) {
      this.$emit('change', [val, this.time])
    },
    time(val) {
      this.$emit('change', [this.day, val])
    },
  },
  created() {
    if (!this.value) {
      this.day = 1
      this.time = moment()
      return
    }
    this.day = this.value[0]
    this.time = this.value[1]
  },
  render() {
    return (
      <div style="display: inline-flex; align-items: center">
        <a-select v-model={this.day} style="width: 80px">
          <a-select-option value="1">{this.$t('page_dform_yesterday')}</a-select-option>
          <a-select-option value="2">{this.$t('page_dform_today')}</a-select-option>
          <a-select-option value="3">{this.$t('page_dform_tomorrow')}</a-select-option>
        </a-select>
        <a-time-picker v-model={this.time} format="HH:mm" style="width: 128px" />
      </div>
    )
  },
})
